<template>
    <div class="news-events">
        <b-overlay :show="loading" rounded="sm" class="news-overlay">
            <div v-if="!loading && newsList.length > 0" class="news-content">
                <!-- 标题 -->
                <div class="news-title">{{ $t("lbl_EMPBE_NewsEvents") }}</div>
                
                <!-- 内容区域 -->
                <div class="news-content-wrapper">
                    <!-- 表头 -->
                    <div class="news-header-row">
                        <div class="news-header-col news-header-update">
                            <div class="news-header-text">{{ $t('lbl_EMPBE_LatestNews') }}</div>
                        </div>
                        <div class="news-header-col news-header-date">
                            <div class="news-header-text">{{ $t('lbl_EMPBE_PublishDate') }}</div>
                        </div>
                    </div>
                    
                    <!-- 数据列表（可滚动） -->
                    <div class="news-list-container">
                        <div 
                            v-for="(item, index) in newsList" 
                            :key="item.id || index" 
                            class="news-row"
                            :class="{ 'news-row-alt': index % 2 === 0 }"
                            @click="handleItemClick(item)"
                        >
                            <div class="news-col news-col-update">
                                <div class="news-text">{{ item.title }}</div>
                            </div>
                            <div class="news-col news-col-date">
                                <div class="news-text news-date-text">{{ formatDate(item.publishDate) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="!loading && newsList.length === 0" class="empty-state">
                <p>{{ $t('lbl_EMPBE_NoNewsEvents') }}</p>
            </div>
        </b-overlay>
    </div>
</template>
<script>
import { ExhibitionNewsService } from '../../../_services/exhibitionnews';

export default {
    name: 'NewsEvents',
    data() {
        return {
            loading: false,
            newsList: []
        };
    },
    computed: {
        langid() {
            return parseInt(localStorage.getItem("currentLangId") || "936");
        }
    },
    mounted() {
        this.loadNews();
    },
    methods: {
        async loadNews() {
            this.loading = true;
            try {
                const response = await ExhibitionNewsService.GetIndustryNews(this.langid);
                
                if (response && response.isSuccessful === true && response.data) {
                    // 根据后端 EMP_News 类结构，字段为：List_NewsTitle, List_Link, PublishDate, Id
                    const normalizedList = (response.data || []).map((item, index) => {
                        return {
                            id: item.Id || item.id || index,
                            title: item.List_NewsTitle || item.list_NewsTitle || '',
                            link: item.List_Link || item.list_Link || '',
                            publishDate: item.PublishDate || item.publishDate || null
                        };
                    }).sort((a, b) => {
                        // 按 PublishDate 倒序排列，最新的在前面
                        const dateA = a.publishDate ? new Date(a.publishDate).getTime() : 0;
                        const dateB = b.publishDate ? new Date(b.publishDate).getTime() : 0;
                        return dateB - dateA;
                    });
                    this.newsList = normalizedList;
                } else {
                    this.newsList = [];
                    if (response && response.msg && response.msg.length > 0) {
                        console.error('获取行业动态失败:', response.msg);
                    } else if (response && response.systemErrorMsg && response.systemErrorMsg.length > 0) {
                        console.error('获取行业动态失败:', response.systemErrorMsg);
                    }
                }
            } catch (error) {
                console.error('加载行业动态数据失败:', error);
                this.newsList = [];
            } finally {
                this.loading = false;
            }
        },
        formatDate(dateString) {
            if (!dateString) return '';
            try {
                const date = new Date(dateString);
                const year = date.getFullYear();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                return `${year}/${month}`;
            } catch (error) {
                return dateString;
            }
        },
        handleItemClick(item) {
            if (item.link) {
                window.open(item.link, '_blank');
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.news-events {
    width: 100%;
    height: 100%;
    min-height: 500px;
    padding: 16px;
    background: white;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, .25);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 16px;
    box-sizing: border-box;
    overflow: visible;
    position: relative;

    .news-overlay {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
        width: 100%;
        
        ::v-deep .b-overlay-wrap {
            display: flex;
            flex-direction: column;
            flex: 1;
            min-height: 0;
            width: 100%;
        }
    }

    .news-content {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
        width: 100%;
        gap: 16px;
    }

    .news-title {
        justify-content: center;
        display: flex;
        flex-direction: column;
        color: rgba(0, 0, 0, 0.80);
        font-size: 16px;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        font-weight: 600;
        line-height: 20.80px;
        word-wrap: break-word;
        margin: 0;
        flex-shrink: 0;
    }

    .news-content-wrapper {
        align-self: stretch;
        justify-content: flex-start;
        align-items: flex-start;
        display: flex;
        flex-direction: column;
        flex: 1 1 0;
        min-height: 0;
        overflow: hidden;
        padding-bottom: 0;
        width: 100%;
    }

    .news-header-row {
        align-self: stretch;
        justify-content: flex-start;
        align-items: center;
        display: flex;
        flex-shrink: 0;
        width: 100%;
    }

    .news-header-col {
        height: 35px;
        padding: 10px;
        justify-content: flex-start;
        align-items: center;
        gap: 10px;
        display: flex;

        &.news-header-update {
            flex: 1 1 0;
        }

        &.news-header-date {
            justify-content: center;
        }
    }

    .news-header-text {
        justify-content: center;
        display: flex;
        flex-direction: column;
        color: rgba(0, 0, 0, 0.80);
        font-size: 16px;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        font-weight: 600;
        line-height: 20.80px;
        word-wrap: break-word;
        margin: 0;
        white-space: nowrap;
    }

    .news-list-container {
        flex: 1 1 0;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        display: flex;
        overflow-y: auto;
        overflow-x: hidden;
        min-height: 0;
        max-height: 100%;
        margin-bottom: 0;
        padding-bottom: 0;
        width: 100%;
        
        /* 确保滚动条始终可见 */
        &::-webkit-scrollbar {
            width: 14px;
            -webkit-appearance: none;
        }
        
        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 7px;
        }
        
        &::-webkit-scrollbar-thumb {
            background: rgba(0, 0, 0, 0.3);
            border-radius: 7px;
            border: 2px solid #f1f1f1;
            
            &:hover {
                background: rgba(0, 0, 0, 0.5);
            }
        }
        
        /* Firefox */
        scrollbar-width: auto;
        scrollbar-color: rgba(0, 0, 0, 0.3) #f1f1f1;
    }

    .news-row {
        align-self: stretch;
        padding: 12px;
        justify-content: flex-start;
        align-items: center;
        gap: 8px;
        display: flex;
        cursor: pointer;
        transition: background-color 0.15s ease;
        flex-shrink: 0;
        margin-bottom: 0;
        width: 100%;

        &:last-child {
            margin-bottom: 0;
        }

        &:hover {
            background-color: rgba(249, 249, 249, 0.6);
        }

        &.news-row-alt {
            background: #F9F9F9;
            
            &:hover {
                background-color: rgba(249, 249, 249, 0.8);
            }
        }
    }

    .news-col {
        justify-content: center;
        align-items: center;
        gap: 10px;
        display: flex;

        &.news-col-update {
            flex: 1 1 0;
        }

        &.news-col-date {
            flex-shrink: 0;
        }
    }

    .news-text {
        flex: 1 1 0;
        justify-content: center;
        display: flex;
        flex-direction: column;
        color: rgba(0, 0, 0, 0.80);
        font-size: 14px;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        font-weight: 400;
        line-height: 18.20px;
        word-wrap: break-word;
        margin: 0;

        &.news-date-text {
            flex: 0 0 auto;
            min-width: fit-content;
        }
    }

    .empty-state {
        text-align: center;
        padding: 40px 20px;
        color: rgba(0, 0, 0, 0.60);
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

        p {
            margin: 0;
            font-size: 14px;
        }
    }
}
</style>

